import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import { useEffect, useRef, useState } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import * as bie from "react-bootstrap"
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios'
import { config } from '../../CommonUtils/CommonURLS'
import { useSelector } from 'react-redux'
import { GetDepartments, GetDesignations, GetSubjectList } from '../../Reducers/AffiliationCommonservice'
import allowNumbersOnly, { allowAlphabetAndSpacesOnly, handlePaste } from '../../CommonUtils/CommonValidations'
import Swal from 'sweetalert2'
import { failureAlert } from '../../CommonUtils/SweetAlerts'
import { ERROR_MSG, MOBILE_VALIDATION } from '../../CommonUtils/contextVariables'
import * as Yup from 'yup';
import moment from 'moment';
import CommonReactTable from '../../CommonUtils/CommonReactTable'
export default function UniversitywiseAffiliationDetails2023() {
    const Designations = useSelector((state) => state?.commonMastersReducer?.DesignationList);
    const DeptList = useSelector((state) => state?.commonMastersReducer?.Deptlist);
    const Sublist = useSelector((state) => state?.commonMastersReducer?.subList);
    const instName = sessionStorage.getItem('instName');
    const [SubmittedRes, setSubmittedRes] = useState();
    const [showmsg, setmsg] = useState(false);
    const [clgcmpltedsstatus, setclgcmpltedsstatus] = useState([]);
    const hasFetchedData = useRef(false);
    const UniversitywiseAfflValidations = Yup.object().shape({
        officerName: Yup.string().required(ERROR_MSG).nullable(),
        officerDesignation: Yup.string().required(ERROR_MSG).nullable(),
        presentlyWrkng: Yup.string().required(ERROR_MSG).nullable(),
        mobileNo: Yup.string().required(ERROR_MSG).matches(MOBILE_VALIDATION, "Invalid mobile number").nullable(),

        univAssocYears: Yup.string().required(ERROR_MSG).nullable(),
        dateOfInspec: Yup.string().required(ERROR_MSG).nullable(),
        inspecDateColleges: Yup.string().required(ERROR_MSG).nullable(),
        deptCode: Yup.string().required(ERROR_MSG).nullable(),
        verificationType: Yup.string().required(ERROR_MSG).nullable(),
        officerWorkingAtOther: Yup.string().when('presentlyWrkng', {
            is: '9999',
            then: Yup.string().required('required'),
            otherwise: Yup.string().nullable(),
        }),
    })
    const [showModal, setShowModal] = useState(false);
    const handleClose = () => setShowModal(false);

    const handleView = (student) => {

        setShowModal(true);
    }

    const UnivwiseafflDtls = useFormik({
        initialValues: {

            officerName: "",
            officerDesignation: "",
            presentlyWrkng: "",
            mobileNo: "",
            univIssuedIdNo: "",
            cfmsIdNo: "",
            univAssocYears: "",
            dateOfInspec: "",
            inspecDateColleges: "",
            deptCode: "",
            aadhar: "",
            verificationType: "",
            officerWorkingAtOther: ""

        },
        validationSchema: UniversitywiseAfflValidations,
        onSubmit: (values) => {
            const updatedValues = {
                ...values,
                mobileNo: parseInt(values.mobileNo || ""),
                univAssocYears: parseInt(values.univAssocYears || ""),
                inspecDateColleges: parseInt(values.inspecDateColleges || ""),
                deptCode: parseInt(values.deptCode || ""),
                aadhar: parseInt(values.aadhar || ""),
                collCode: collcode,
            };
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.API_URL}UniversitywiseAffiliationDetails`;
                    CommonAxiosPost(url, updatedValues).then((res) => {
                        if (res?.data?.scode === '01') {
                            Swal.fire({
                                text: res?.data?.sdesc,
                                icon: 'success',
                                backdrop: false
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    setSubmittedRes(res?.data);
                                    setmsg(true)
                                } else if (result.dismiss === Swal.DismissReason.cancel) {
                                    console.log("User canceled the alert.");
                                }
                            })
                        } else {
                            failureAlert(res?.data?.sdesc);

                        }
                    });
                } else {
                    console.log('Submission canceled');
                }
            });

        },
    })


    function GetBuildingReport() {
        let url = config?.url?.API_URL + "getclgCpltedStatus";
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === "01") {
                setclgcmpltedsstatus(res?.data?.clgCpltedStatus);

            }
            else {
                setclgcmpltedsstatus([]);



            }

        })
    }
    function GetTeamData(clgcode) {
        let url = config?.url?.API_URL + "getTeamData/" + clgcode;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.status === true) {
                res?.data?.TeamData?.forEach((univData, i) => {
                    const DateofInsp = univData?.date_of_inspec && moment(univData?.date_of_inspec,
                        'DD/MM/YYYY', true).isValid() ? moment(univData?.date_of_inspec, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';
                    UnivwiseafflDtls?.setFieldValue("officerName", univData?.officer_name);
                    UnivwiseafflDtls?.setFieldValue("officerDesignation", univData?.officer_designation);
                    UnivwiseafflDtls?.setFieldValue("presentlyWrkng", univData?.presently_wrkng);
                    UnivwiseafflDtls?.setFieldValue("mobileNo", univData?.mobile_no);
                    UnivwiseafflDtls?.setFieldValue("univIssuedIdNo", univData?.univ_issued_id_no);
                    UnivwiseafflDtls?.setFieldValue("cfmsIdNo", univData?.cfms_id_no);
                    UnivwiseafflDtls?.setFieldValue("univAssocYears", univData?.univ_assoc_years);
                    UnivwiseafflDtls?.setFieldValue("dateOfInspec", DateofInsp ?? '',);
                    UnivwiseafflDtls?.setFieldValue("inspecDateColleges", univData?.inspec_date_colleges);
                    UnivwiseafflDtls?.setFieldValue("deptCode", univData?.dept_code);
                    UnivwiseafflDtls?.setFieldValue("aadhar", univData?.aadhar);
                    UnivwiseafflDtls?.setFieldValue("verificationType", univData?.verification_type);
                    UnivwiseafflDtls?.setFieldValue("officerWorkingAtOther", univData?.officer_working_at_other || '');



                })

            }
            else {
                console.log("Data not Found")

            }

        })
    }
    useEffect(() => {
        if (!hasFetchedData.current) {
            GetBuildingReport();
            GetDesignations();
            GetDepartments();
            GetSubjectList();
            hasFetchedData.current = true
        }
    }, [])

    const [InstName, setInstName] = useState([]);
    const [collcode, setcollcode] = useState([]);
    const [userId, setuserId] = useState([]);


    const Columns = [
        { Header: "Sl.no", accessor: (row, index) => index + 1, },
        { Header: "College Code", accessor: "coll_code", },
        {
            Header: "College Name", accessor: "inst_name",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.inst_name}</div>
            ),
        },


        {
            Header: "College Nature", accessor: "coll_nature_name",

            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.coll_nature_name}</div>
            ),
        },
        {
            Header: "Contact Details", accessor: "mobile_email",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.mobile_email}</div>
            ),
        },
        { Header: "FFCA UserID", accessor: "user_id", },
        {
            Header: "Mapping for reset Password", accessor: "case",
            Cell: ({ row }) => <div>
                <button type='submit' className='btn btn-success btn-sm float-end rounded mb-2' onClick={(e) => {
                    handleView(); GetTeamData(row?.original?.coll_code); setmsg(false);
                    setInstName(row?.original?.inst_name); setcollcode(row?.original?.coll_code); setuserId(row?.original?.user_id)
                }}>
                    Mapping or Reset Password</button>
            </div>
        },
    ]
    return (
        <>
            <CommonFormHeading heading={`${instName}  100% Completed Colleges`} />

            <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                <FormikProvider value={UnivwiseafflDtls}>
                    <Form onChange={UnivwiseafflDtls.handleChange} onSubmit={UnivwiseafflDtls.handleSubmit} className="affl-form" >
                        <bie.Row className="px-2 pt-3 mb-3 w-100">
                            {clgcmpltedsstatus?.length > 0 ? (<>
                                <div className="table-responsive">
                                    <CommonReactTable data={clgcmpltedsstatus} columns={Columns} filename="UniversityWiseAffiliationDetails" headerName={`University Wise Affiliation Details`} />
                                </div>
                            </>) : <center className="text-danger h6">*** No Data Found ***</center>}
                            <bie.Modal show={showModal} onHide={handleClose} size="xl">
                                <bie.Modal.Header style={{ backgroundColor: '#6f7cc3' }} >
                                    <bie.Modal.Title style={{ textAlign: "center", width: "100%" }}>Reset Password for FFCA Team of  {InstName}</bie.Modal.Title>
                                </bie.Modal.Header>
                                <bie.Modal.Body>

                                    <FormikProvider value={UnivwiseafflDtls}>
                                        <Form onSubmit={UnivwiseafflDtls?.handleSubmit} onChange={UnivwiseafflDtls?.handleChange} className='affl-form'>
                                            <>
                                                {showmsg === true ? (<>
                                                    <bie.Alert variant='danger'>
                                                        <p className='mb-0'>
                                                            Password Reset Successful. User Details of FFCA-
                                                            <strong>{InstName}</strong> sent to FFCA Convenor -
                                                            <span className="highlight">  {UnivwiseafflDtls?.values?.officerName}</span>   <br />
                                                            <p className='cen mb-0'>
                                                                User-ID: <span className="highlight user-id">{userId}</span>
                                                                Password: <span className="highlight password">{SubmittedRes?.smsId}</span> SMS Sent.
                                                            </p>
                                                        </p>
                                                    </bie.Alert>
                                                </>) : (<>
                                                    <bie.Alert variant='danger'>
                                                        <p className='mb-0'>
                                                            <strong>Note:</strong> Please enter one FFCA Team Head details so that this Password will be sent to their Mobile.
                                                            <br />
                                                            Aadhaar and university ID details are not mandatory.
                                                        </p>
                                                    </bie.Alert>
                                                </>)}

                                                {showmsg === false ? (<>

                                                    <bie.Row>
                                                        <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                                            {/* <bie.InputGroup className="mb-4p5"> */}
                                                            <label className='mb-1'> <b className="field-mandatory">Team Head Name</b> </label>
                                                            <Field type='text' name="officerName" onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e); }}
                                                                className="form-control mb-2" maxLength={70}></Field>
                                                            <ErrorMessage name="officerName" component="div" className="text-error" />
                                                            {/*</bie.InputGroup> */}
                                                        </bie.Col>
                                                        <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                                            {/* <bie.InputGroup className="mb-4p5"> */}
                                                            <label className='mb-1'> <b className="field-mandatory">Department</b> </label>
                                                            <Field as="select" name="deptCode" className="form-control mb-2">

                                                                <option value=''>--SELECT--</option>

                                                                {DeptList && DeptList.map((rel, i) => (
                                                                    <option value={rel?.board_discipline_group_id}>{rel?.board_discipline_group}</option>
                                                                ))}
                                                            </Field>
                                                            <ErrorMessage name="deptCode" component="div" className="text-error" />
                                                            {/*</bie.InputGroup> */}
                                                        </bie.Col>
                                                        <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                                            {/* <bie.InputGroup className="mb-4p5"> */}
                                                            <label className='mb-1'> <b className="field-mandatory">Team Head Designation </b> </label>
                                                            <Field as="select" name="officerDesignation" className="form-control mb-2">
                                                                <option value=''>--SELECT--</option>

                                                                {Designations && Designations.map((rel, i) => (
                                                                    <option value={rel?.desig_code}>{rel?.designation_name}</option>
                                                                ))}
                                                            </Field>

                                                            <ErrorMessage name="officerDesignation" component="div" className="text-error" />
                                                            {/*</bie.InputGroup> */}
                                                        </bie.Col>
                                                        <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                                            {/* <bie.InputGroup className="mb-4p5"> */}
                                                            <label className='mb-1'> <b className="field-mandatory">Presently Working at</b> </label>
                                                            <Field as="select" name="presentlyWrkng" className="form-control mb-2" onChange={(e) => {
                                                                UnivwiseafflDtls?.setFieldValue("officerWorkingAtOther", "")
                                                            }}  >
                                                                <option value=''>--SELECT--</option>

                                                                {Sublist && Sublist?.map((rel, i) => (
                                                                    <option value={rel?.ub_code}>{rel?.ub_name}</option>
                                                                ))}
                                                                <option value="9999">Other University</option>

                                                            </Field>
                                                            <ErrorMessage name="presentlyWrkng" component="div" className="text-error" />
                                                            {/*</bie.InputGroup> */}
                                                        </bie.Col>
                                                        {UnivwiseafflDtls?.values?.presentlyWrkng === "9999" ? (<>
                                                            <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                                                {/* <bie.InputGroup className="mb-4p5"> */}
                                                                <label className='mb-1'> <b className="field-mandatory">Other University name</b> </label>
                                                                <Field type="text" name="officerWorkingAtOther" className="form-control mb-2" />
                                                                <ErrorMessage name="officerWorkingAtOther" component="div" className="text-error" />
                                                                {/*</bie.InputGroup> */}
                                                            </bie.Col>
                                                        </>) : (<></>)}

                                                        < bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                                            {/* <bie.InputGroup className="mb-4p5"> */}
                                                            <label className='mb-1'> <b className="">Aadhaar</b> </label>
                                                            <Field type="text" name="aadhar" className="form-control mb-2"
                                                                onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} maxLength={12}></Field>

                                                        </bie.Col>
                                                        < bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                                            <label className='mb-1'> <b className="">University issued id No</b> </label>
                                                            <Field type="text" name="univIssuedIdNo" className="form-control mb-2" maxLength="10"></Field>
                                                        </bie.Col>
                                                        < bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                                            <label className='mb-1'> <b className="">CFMS id/Emp id</b> </label>
                                                            <Field type="text" name="cfmsIdNo" className="form-control mb-2 mt-3" maxLength="10" onKeyPress={(e) => {
                                                                allowNumbersOnly(e)
                                                            }} onPaste={(e) => handlePaste(e)} ></Field>
                                                        </bie.Col>  < bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                                            <label className='mb-1'> <b className="field-mandatory">No of years of association with the university</b> </label>
                                                            <Field type="text" name="univAssocYears" className="form-control mb-2" maxLength="2" onKeyPress={(e) => {
                                                                allowNumbersOnly(e)
                                                            }} onPaste={(e) => handlePaste(e)}></Field>
                                                            <ErrorMessage name="univAssocYears" component="div" className="text-error" />
                                                        </bie.Col>
                                                        < bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                                            <label className='mb-1'> <b className="field-mandatory">College Assigned </b> </label>
                                                            <Field type="text" name="itemRateUpperLimit" className="form-control mb-2 mt-3" disabled value={InstName} />
                                                            <ErrorMessage name="itemRateUpperLimit" component="div" className="text-error" />
                                                        </bie.Col>
                                                        < bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                                            <label className='mb-1'> <b className="field-mandatory">Date of inspection</b> </label>
                                                            <Field type="date" name="dateOfInspec" className="form-control mb-2 mt-4" onKeyDown={(e) => { e.preventDefault() }}
                                                                min={new Date().toISOString().split('T')[0]}
                                                            ></Field>
                                                            <ErrorMessage name="dateOfInspec" component="div" className="text-error" />
                                                        </bie.Col>
                                                        < bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='pt-2'>
                                                            <label className='mb-1'> <b className="field-mandatory">No of inspection being attended of the same  date</b> </label>
                                                            <Field type="text" name="inspecDateColleges" className="form-control mb-2" maxLength="5" onKeyPress={(e) => {
                                                                allowNumbersOnly(e)
                                                            }} onPaste={(e) => handlePaste(e)} />
                                                            <ErrorMessage name="inspecDateColleges" component="div" className="text-error" />
                                                        </bie.Col>
                                                        < bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                                            <label className='mb-1'> <b className="field-mandatory">Contact No</b> </label>
                                                            <Field type="text" name="mobileNo" className="form-control mt-4 "
                                                                onKeyPress={(e) => { allowNumbersOnly(e) }} onPaste={(e) => handlePaste(e)} maxLength={10}></Field>
                                                            <ErrorMessage name="mobileNo" component="div" className="text-error" />
                                                        </bie.Col>

                                                        < bie.Col xs={12} sm={12} md={12} lg={4} xl={6} xxl={6}>
                                                            <label className='mb-1'> <b className="field-mandatory">Whether conducting  physical verification (or)
                                                                virtual verification</b> </label>
                                                            <Field as="select" name="verificationType" className="form-control mb-2" >

                                                                <option value=''>---select---</option>
                                                                <option value="Physical_Verification"> Physical Verification </option>
                                                                <option value="Virtual_Verification">  Virtual Verification</option>

                                                            </Field>
                                                            <ErrorMessage name="verificationType" component="div" className="text-error" />
                                                        </bie.Col>
                                                    </bie.Row>
                                                </>) : (<></>)}

                                                <bie.Row>
                                                    <div className='d-flex flex-row justify-content-end pt-3'>
                                                        <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1} className='pt-2'>
                                                            <button
                                                                type="button"
                                                                className="btn btn-success rounded-pill   close-btn"
                                                                onClick={(e) => {
                                                                    UnivwiseafflDtls?.resetForm(); handleClose();
                                                                }}>Close</button>
                                                        </bie.Col> &emsp;
                                                        {showmsg === false ? (
                                                            <>
                                                                <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>

                                                                    <button type="submit" className="btn btn-primary">

                                                                        Create/Reset Password and send SMS to Team Head
                                                                    </button>
                                                                </bie.Col>
                                                            </>
                                                        ) : (<></>)}
                                                    </div>
                                                </bie.Row>
                                            </>
                                        </Form>
                                    </FormikProvider>

                                </bie.Modal.Body>
                            </bie.Modal>

                        </bie.Row>
                    </Form>
                </FormikProvider>
            </bie.Container>
        </>
    )
}
